export default "__VITE_ASSET__BAFN7fJI__"